import { Link } from "react-router-dom";

const STAGES = [
  { key: "overview", label: "Overview", path: "" },
  { key: "sources", label: "Sources", path: "/sources" },
  { key: "generate", label: "Generate", path: "/generate" },
  { key: "review", label: "Review", path: "/review" },
  { key: "export", label: "Export", path: "/export" },
] as const;

export type PipelineStage = (typeof STAGES)[number]["key"];

/**
 * The Decks / project-name breadcrumb, plus a row of links to each stage of
 * the Upload → Understand → Generate → Review → Export pipeline (the same
 * framing the landing page and README already use). Shown at the top of all
 * five project pages so moving between them is one click.
 */
export default function PipelineNav({
  projectId,
  projectName,
  current,
}: {
  projectId: string;
  projectName: string;
  current: PipelineStage;
}) {
  return (
    <div className="stack" style={{ gap: 8, marginBottom: 16 }}>
      <div className="crumbs">
        <Link to="/">Decks</Link>
        <span className="sep">/</span>
        <span>{projectName}</span>
      </div>
      <div className="row row-wrap" style={{ gap: 6 }}>
        {STAGES.map((stage) => (
          <Link
            key={stage.key}
            to={`/projects/${projectId}${stage.path}`}
            className={`chip ${stage.key === current ? "chip-accent" : "chip-outline"}`}
          >
            {stage.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
